<script>
import Layout from "../../../layouts/manage";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Screen from "../../../../components/screen";
import Button from "@/components/c-button";
import Input from "@/components/c-input";
// import Dropzone from "@/components/c-dropzone";
import Select from "@/components/c-select";
import Search from "@/components/c-select-search";

import { rentRecordService } from "../../../../services/managements/rents/rentrecord.service";
import { propertyService } from "../../../../services/managements/propertyservice/property.service";
import { customerService } from "../../../../services/contactservice/customer.service";

import i18n from "../../../../i18n";
import Loading from "@/components/c-loading";
/* eslint-disable no-console */
/**
 * Contacts-list component
 */
export default {
  extends: Screen,
  page: {
    title: "Approve Terminate Form",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { 
    Layout, 
    PageHeader, 
    Loading, 
    Button,
    Input,
    Select,
    Search,
  },
  data() {
    return {
      dropdownSelection: {},
   
      fetchingStats: false,
      tryingToSubmit: false,
      title: "Approve Terminate",
      breadCrumb: {},


      projectData: {},
      propertyData: {},
      customerData: {},
      user: JSON.parse(localStorage.getItem('user')),

      dataProjectId: 1,
      dataPropertyName: '',
      dataCustomerId: 0,
      dataPropertyId: 0,
    };
  },
  mounted() {

    let hasId = 'id' in this.$route.params;
    if(hasId) {
      this.loadingData(this.$route.params.id);     
    } else {
      this.loadingData(0);     
    }
  },
 
  methods: {
    loadingData: function(id) {
      this.fetchingStats = true;
      propertyService.getOne(id)
        .then(response => {
          if(id != 0){
            this.dataProjectId = response.data.project_id;
            this.propertyData = response.data;
            this.dataPropertyId = this.propertyData.id
            this.dataPropertyName = this.propertyData.code
            this.dataCustomerId = response.data.tenant_id;
          }
          this.loadingSettings(response.setting);
          this.loadingCustomerData();
        });

    },

    loadingSettings: function(setting) {
      this.projectData = {data: setting.projects};
      this.propertyData = {data: setting.properties};
    },

    loadingCustomerData: function() {
      let param = '?page=0';
      customerService.getList(param)
        .then(response => {
          this.customerData = response.data;
        });
    },

    submitCancel: function() {

      this.$swal.fire({
        title: i18n.t('general.cancel-confirm.title'),
        text: i18n.t('general.cancel-confirm.message'),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: i18n.t('general.cancel-confirm.yes'),
        cancelButtonText: i18n.t('general.cancel')
      }).then(result => {
        if (result.value) {

          this.$router.push(this.$route.query.redirectFrom || {
              name: "manage-property"
          });

        }
      });
    
    },
    submitSave: function() {
      
      this.tryingToSubmit = true;

      let dataSubmit = {
        property_id : this.dataPropertyId,
        created_by : this.user.id,
      }
        console.log(dataSubmit);
        rentRecordService.approveTerminate(dataSubmit)
         .then(response => {
           this.tryingToSubmit = false;
            console.log(response);
           if(response.status == 200) {
              this.$swal.fire({
              title: i18n.t('general.success.title'),
              text: i18n.t('general.success.message'),
              icon: "success",
              showCancelButton: false,
              confirmButtonColor: "#34c38f",
              cancelButtonColor: "#f46a6a",
              confirmButtonText: i18n.t('general.ok'),
              cancelButtonText: i18n.t('general.success.no')
            }).then(result => {
              if (result.value) {
                this.$router.push(this.$route.query.redirectFrom || {
                  name: "manage-property",
                });
              }
            });
           }
          
        });

    },


    clearForm: function() {

      this.dataProperty = 0;

    },

  },
};
</script>

<template>
  <Layout>
    <div>
      <PageHeader :items="[{
        text: $t('property.text'),
        href: '/manage/property',
      }, {
        text: 'យល់ព្រមចាកចេញ',
        active: true
      }]" :title="'យល់ព្រមចាកចេញ'" />
    </div>
    

    <Loading :loaded="fetchingStats" />
    <b-form v-show="fetchingStats" @submit.prevent="submitSave" class="row">
    
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
              
            <div class="row">
                <div class="col-md-4">
                <Select
                  @change="projectChanged" 
                  :id="'project_id'"
                  :disabled="true"
                  v-model="dataProjectId"
                  :list="this.projectData"
                  :label="'property.project'"
                  :require="true"
                    /> 
              </div>
              <div class="col-lg-4">
                <Input 
                  :id="'property_id'"
                  :disabled="true"
                  v-model="dataPropertyName"
                  :label="'property.text'" 
                />
              </div>
              <div class="col-sm">
                  <Search 
                    :text="'name'"
                    :id="'customer_id'"
                    :editable="false"
                    v-model="dataCustomerId"
                    :list="{data: customerData}"
                    :require="true"
                    :label="'customer.text'"  />
              </div>
            </div>
            <br>
            <div class="row">
              <div class="col-lg-12">

                <div inline class="row gy-2 gx-3 align-items-end">
                  <div class="col-sm-auto">
                    <Button v-bind:icon="'bx bx-x-circle'" 
                      v-bind:buttonType="'button'"
                      v-bind:variant="'danger'"
                      @click="submitCancel()"
                      v-bind:title="$t('general.cancel')"  />
                  </div>
                  <div class="col-sm-auto">
                    <Button v-bind:icon="'bx bx-save bx-tada'" 
                      v-bind:buttonType="'button'"
                      @click="submitSave()"
                      v-bind:requesting="tryingToSubmit"
                      v-bind:title="$t('general.save')"  />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </b-form> 
  </Layout>
</template>